/* Package JSON Import will be here */
import { filter, includes, findIndex, indexOf, sortBy, remove } from "lodash";
/* Package JSON Import will be here */

/* Project Import will be here */
import { getErrorObject, errorToast } from "utilities/utils";
import { ISelectedAttrFilter, IGetAttrFilterParams } from "models/filterModels";
import Constants from "utilities/appConstants";
import { getAttrFilterListApi } from "services/filter";
import { getRewardsProductList } from "reducers/rewards/rewardsOrderProducts";
import { getRewardVendorListApi } from "services/rewards/rewards";
import { showMsgFromJson } from "reducers/common";
/* Project Import will be here */

export const types = {
    REWARD_ATTR_FILTER_REQUEST: "rewardsAttrFilter/REWARD_ATTR_FILTER_REQUEST",
    REWARD_ATTR_FILTER_SUCCESS: "rewardsAttrFilter/REWARD_ATTR_FILTER_SUCCESS",
    REWARD_ATTR_FILTER_FAILURE: "rewardsAttrFilter/REWARD_ATTR_FILTER_FAILURE",
    ON_CHANGE_REWARD_ATTR_FILTER: "rewardsAttrFilter/ON_CHANGE_REWARD_ATTR_FILTER",
    UPDATE_SELECTED_REWARD_SORTING_FILTER: "rewardsAttrFilter/UPDATE_SELECTED_REWARD_SORTING_FILTER",
    UPDATE_REWARD_POINT_RANGE_FILTER: "rewardsAttrFilter/UPDATE_REWARD_POINT_RANGE_FILTER",
    UPDATE_REWARD_RANGE_MAX_SORTING_FILTER: "rewardsAttrFilter/UPDATE_REWARD_RANGE_MAX_SORTING_FILTER",
    RESET_REWARD_FILTER: "rewardsAttrFilter/RESET_REWARD_FILTER",
    UPDATE_SELECT_VENDOR_FILTER: "rewardsAttrFilter/UPDATE_SELECT_VENDOR_FILTER",
    REWARD_ATTR_VENDOR_FILTER_REQUEST: "rewardsAttrFilter/REWARD_ATTR_VENDOR_FILTER_REQUEST",
    REWARD_ATTR_VENDOR_FILTER_SUCCESS: "rewardsAttrFilter/REWARD_ATTR_VENDOR_FILTER_SUCCESS",
    REWARD_ATTR_VENDOR_FILTER_FAILURE: "rewardsAttrFilter/REWARD_ATTR_VENDOR_FILTER_FAILURE",
};

let initialState = {
    isLoading: false,
    isVendorLoading: false,
    data: [],
    vendorData: [],
    selectedAttrFilter: [],
    selectedVendor: [],
    selectedSortingFilter: Constants.POINT_ASC,
    minPrice: 0,
    maxPrice: 0,
    error: null
};

export const rewardsAttrFilter = (state = initialState, action) => {
    switch (action.type) {
        case types.REWARD_ATTR_FILTER_REQUEST:
            return {
                ...state,
                isLoading: true
            };
        case types.REWARD_ATTR_FILTER_SUCCESS:
            return {
                ...state,
                ...action.payload,
                isLoading: false
            };
        case types.REWARD_ATTR_FILTER_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error
            };

        case types.ON_CHANGE_REWARD_ATTR_FILTER:
            return {
                ...state,
                ...action.payload,
            };

        case types.UPDATE_SELECTED_REWARD_SORTING_FILTER:
            return {
                ...state,
                ...action.payload,
            };

        case types.UPDATE_REWARD_POINT_RANGE_FILTER:
            return {
                ...state,
                ...action.payload,
            };

        case types.RESET_REWARD_FILTER:
            return {
                ...initialState,
                data: state.data,
                vendorData: state.vendorData
            };

        case types.UPDATE_SELECT_VENDOR_FILTER:
            return {
                ...state,
                ...action.payload,
            };

        case types.REWARD_ATTR_VENDOR_FILTER_REQUEST:
            return {
                ...state,
                isVendorLoading: true
            };

        case types.REWARD_ATTR_VENDOR_FILTER_SUCCESS:
            return {
                ...state,
                ...action.payload,
                isVendorLoading: false
            };

        case types.REWARD_ATTR_VENDOR_FILTER_FAILURE:
            return {
                ...state,
                isVendorLoading: false,
                vendorData: [],
                selectedVendor: [],
                error: action.payload.error
            };

        default:
            return state;
    }
};

/* Get product attribute filter and value list */
export const getRewardAttrFilterList = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.REWARD_ATTR_FILTER_REQUEST });
        try {
            let requestObj: IGetAttrFilterParams = {
                ids: [],
                isProductAttr: false
            };
            const response = await getAttrFilterListApi(requestObj);

            /* Delete empty attr value attributes */
            var activeAttrs = remove(response.data.Data, (n) => {
                return n.AttrValues.length > 0;
            });

            /* Sort attributes based on Sequence property */
            const sortedList = sortBy(activeAttrs, (o) => {
                return o.Sequence;
            });

            dispatch({
                type: types.REWARD_ATTR_FILTER_SUCCESS,
                payload: { data: sortedList }
            });
        }
        catch (error) {
            const { message } = getErrorObject(error);
            dispatch({
                type: types.REWARD_ATTR_FILTER_FAILURE,
                payload: { error: message }
            });
        }
    }
};

/* Handle select or un-select attr value items */
export const onChangeRewardFilterData = (attrId, attrValueId, selectionType) => {
    return async (dispatch, getState) => {
        const attrFilter = getState().attrFilter;
        let tempArray = attrFilter.selectedAttrFilter;

        /* Check if the attr is already selected */
        const selectedAttrData = filter(attrFilter.selectedAttrFilter, (o) => {
            return o.AttrId === attrId;
        })[0];

        if (attrFilter.selectedAttrFilter.length > 0 && selectedAttrData !== undefined) {
            const attrIndex = findIndex(tempArray, (o) => {
                return o.AttrId === attrId;
            });

            /* Check for selection type multiple */
            if (selectionType === Constants.MULTIPLE) {
                if (includes(selectedAttrData.AttrValues, attrValueId)) {
                    if (selectedAttrData.AttrValues.length === 1) {
                        tempArray.splice(attrIndex, 1);
                    }
                    else {
                        const attrValueIndex = indexOf(tempArray[attrIndex].AttrValues, attrValueId);
                        tempArray[attrIndex].AttrValues.splice(attrValueIndex, 1);
                    }
                }
                else {
                    tempArray[attrIndex].AttrValues.push(attrValueId);
                }
            }
            /* Check for selection type single */
            else if (selectionType === Constants.SINGLE) {
                tempArray[attrIndex].AttrValues[0] = attrValueId;
            }
            /* Check for selection type range */
            else if (selectionType === Constants.RANGE) {
                tempArray[attrIndex].AttrRangeValues = attrValueId;
            }
        }
        else {
            const attrData: ISelectedAttrFilter = { AttrId: attrId };

            if (selectionType === Constants.RANGE) {
                attrData.AttrRangeValues = attrValueId;
                attrData.AttrValues = []
            }
            else {
                attrData.AttrRangeValues = [0, 0];
                attrData.AttrValues = [attrValueId]
            }

            tempArray.push(attrData)
        }

        dispatch({
            type: types.ON_CHANGE_REWARD_ATTR_FILTER,
            payload: {
                selectedAttrFilter: tempArray
            }
        });
    }
}


/* Update selected sorting filter */
export const updateSelectedRewardSortingFilter = (filter) => {
    return async (dispatch, getState) => {
        dispatch({
            type: types.UPDATE_SELECTED_REWARD_SORTING_FILTER,
            payload: {
                selectedSortingFilter: filter
            }
        });
    }
}

/* Update product point range min filter */
export const setPointRangeFilter = (value) => {
    return async (dispatch, getState) => {
        dispatch({
            type: types.UPDATE_REWARD_POINT_RANGE_FILTER,
            payload: {
                minPrice: value[0],
                maxPrice: value[1]
            }
        });
    }
}

/* Reset filter */
export const resetRewardFilter = (isFromProductListPage, isFromUnmount = false) => {
    return async (dispatch, getState) => {
        await dispatch({ type: types.RESET_REWARD_FILTER });
        let getRewardsAttrFilter = getState().rewardsAttrFilter;

        if (getRewardsAttrFilter.selectedVendor.length === 0 && getState().appSettings.loyaltyVendorFilterSingleSelection) {
            dispatch({
                type: types.UPDATE_SELECT_VENDOR_FILTER, payload: {
                    selectedVendor: isFromUnmount ? [] : [getRewardsAttrFilter.vendorData[0].VendorId]
                }
            });
        }
        if (isFromProductListPage)
            dispatch(getRewardsProductList());
    }
}

/* Update radio option select vendor filter */
export const setSelectVendorFilterOption = (value) => {

    return async (dispatch, getState) => {
        let tempArray = [];

        /* checkbox validation which allow multiple array value  */
        if (Array.isArray(value)) {
            tempArray = [...value];
        }
        /* radio option validation which allow single array value  */
        else {
            tempArray.push(value);
        }

        dispatch({
            type: types.UPDATE_SELECT_VENDOR_FILTER, payload: {
                selectedVendor: tempArray
            }
        });
    }
}

/* Get product attribute filter and value list */
export const getRewardVendorList = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.REWARD_ATTR_VENDOR_FILTER_REQUEST });
        try {
            const response = await getRewardVendorListApi();
            dispatch({
                type: types.REWARD_ATTR_VENDOR_FILTER_SUCCESS,
                payload: { vendorData: response.data.Data }
            });
            if (getState().rewardsAttrFilter.selectedVendor.length === 0 && getState().appSettings.loyaltyVendorFilterSingleSelection) {
                let tempArray = [];
                tempArray.push(response.data.Data[0].VendorId);
                dispatch({
                    type: types.UPDATE_SELECT_VENDOR_FILTER, payload: {
                        selectedVendor: tempArray
                    }
                });
            }
        }
        catch (error) {
            dispatch(promiseCatchBlock(error, types.REWARD_ATTR_VENDOR_FILTER_FAILURE, false));
        }
    }
};


/* Generic code for promise catch block */
const promiseCatchBlock = (error: any, type: string, showToast: boolean = false) => {
    return (dispatch) => {
        const { message, errorCode } = getErrorObject(error);

        /* Update the error response in the store */
        if (type !== "") {
            dispatch({
                type: type,
                payload: { error: message }
            });
        }

        /* Show error message */
        if (showToast) {
            /* If error code is exist show the error code message or show the error message returned by the API request */
            if (errorCode !== "")
                dispatch(showMsgFromJson(`common.alerts.error.${errorCode}`, Constants.ERROR));
            else
                errorToast({ content: message });
        }
    }
};